import React, { useContext } from 'react';
import { AssistantPropertiesClient, BrainSimulationClient, BusinessClient, CalendarOAuthClient, CalendarTokenClient, CalendarTokenClientV2, ContactClient, ConversationsClient, DigestClient, EnrichedContextClient, FileSystemClient, GeneratedTextClient, IndividualTaskClient, LinkedAccountClient, MeetingTypeClient, MetasiteClient, PulseClient, PulseIdentityClient, PulseTemplateClient, RecipientClient, RecommendationsClient, RoutinesClient, SentryLogger, ServicesFacadeClient, SimulationPresetClient, SiteListClient, SiteMediaFilesClient } from '@wix/ai-scheduling-assistant-common-lib/http';
export const ClientsContext = /*#__PURE__*/React.createContext(null);
let recipientClientSingleton = null;
export const getRecipientClient = () => recipientClientSingleton;
export const ClientsContextProvider = _ref => {
  let {
    httpClient,
    children
  } = _ref;
  const logger = new SentryLogger();
  const assistantPropertiesClient = new AssistantPropertiesClient(httpClient, logger);
  const generatedTextClient = new GeneratedTextClient(httpClient, logger);
  const meetingTypeClient = new MeetingTypeClient(httpClient, logger);
  const businessClient = new BusinessClient(httpClient, logger);
  const linkAccountClient = new LinkedAccountClient(httpClient, logger);
  const servicesFacadeClient = new ServicesFacadeClient(httpClient, logger);
  const contactClient = new ContactClient(httpClient, logger);
  const calendarOAuthClient = new CalendarOAuthClient(httpClient, logger);
  const siteMediaFilesClient = new SiteMediaFilesClient(httpClient, logger);
  const calendarTokenClient = new CalendarTokenClient(httpClient, logger);
  const calendarTokenClientV2 = new CalendarTokenClientV2(httpClient, logger);
  const pulseIdentityClient = new PulseIdentityClient(httpClient, logger);
  const pulseTemplateClient = new PulseTemplateClient(httpClient, logger);
  const pulseClient = new PulseClient(httpClient, logger);
  const recommendationsClient = new RecommendationsClient(httpClient, logger);
  const conversationsClient = new ConversationsClient(httpClient, logger);
  const digestClient = new DigestClient(httpClient, logger);
  const recipientClient = new RecipientClient(httpClient, logger);
  recipientClientSingleton = recipientClient;
  const routinesClient = new RoutinesClient(httpClient, logger);
  const metasiteClient = new MetasiteClient(httpClient, logger);
  const siteListClient = new SiteListClient(httpClient, logger);
  const brainSimulationClient = new BrainSimulationClient(httpClient, logger);
  const enrichedContextClient = new EnrichedContextClient(httpClient, logger);
  const individualTaskClient = new IndividualTaskClient(httpClient, logger);
  const simulationPresetClient = new SimulationPresetClient(httpClient, logger);
  const fileSystemClient = new FileSystemClient(httpClient, logger);
  const context = {
    httpClient,
    assistantPropertiesClient,
    generatedTextClient,
    meetingTypeClient,
    businessClient,
    linkAccountClient,
    servicesFacadeClient,
    contactClient,
    calendarOAuthClient,
    siteMediaFilesClient,
    calendarTokenClient,
    calendarTokenClientV2,
    pulseIdentityClient,
    pulseTemplateClient,
    pulseClient,
    recommendationsClient,
    conversationsClient,
    digestClient,
    recipientClient,
    routinesClient,
    metasiteClient,
    siteListClient,
    brainSimulationClient,
    enrichedContextClient,
    individualTaskClient,
    simulationPresetClient,
    fileSystemClient
  };
  return /*#__PURE__*/React.createElement(ClientsContext.Provider, {
    value: context
  }, children);
};
export function useClientsContext() {
  const context = useContext(ClientsContext);
  if (!context) {
    throw new Error('ClientsContext must be used within an ClientsContextProvider');
  }
  return context;
}
//# sourceMappingURL=ClientsContext.js.map